import * as React from "react";
import {Icon} from "./Icon";

export class FavouriteIcon extends Icon {

  render() {
    return <Icon {...this.props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
        <path d="M45.45,19A1.5,1.5,0,0,0,44,18L29.83,18,25.43,4.49a1.5,1.5,0,0,0-2.85,0L18.17,18,4,18a1.5,1.5,0,0,0-.88,2.71l11.47,8.36L10.2,42.58a1.5,1.5,0,0,0,2.31,1.68L24,35.93l11.49,8.33a1.5,1.5,0,0,0,2.31-1.68L33.43,29.08l11.47-8.36A1.5,1.5,0,0,0,45.45,19Z"/>
      </svg>
    </Icon>;
  }
}
